<div class="row">
    <div class="col-4">
        <label>Finished</label>
    </div>
    <div class="col-8">
        {{exerciseResult.scoring.finished?'true':'false'}}
    </div>
</div>
<div class="row">
    <div class="col-4">
        <label>Marks</label>
    </div>
    <div class="col-8">
        {{exerciseResult.scoring.marksEarned}}/{{exerciseResult.scoring.marksTotal}}
    </div>
</div>
<div *ngFor="let question of exerciseResult.questions">
    <div class="interaction-container" *ngFor="let interaction of question.interactions">
        <div class="row interaction-header">
            <div class="col d-flex justify-content-between">
                <label>{{interaction.type}} interaction </label>
                <span class="ref-id">({{interaction.id}})</span>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div>Progress</div>
            </div>
            <div class="col-8">
                {{progressPercentage(interaction.progress)}}
            </div>
        </div>
        <div *ngIf="errorTags.length>0">
            <div class="skill-group">Skills related to <b>errors</b></div>
            <app-skill-tag-viewer *ngFor="let _tag of errorTags" [tag]="_tag" [tagMap]="exerciseResult.tagDescriptions"></app-skill-tag-viewer>
        </div>
        <div *ngIf="hintTags.length>0">
            <div class="skill-group">Skills related to <b>hints</b></div>
             <app-skill-tag-viewer *ngFor="let _tag of hintTags" [tag]="_tag" [tagMap]="exerciseResult.tagDescriptions"></app-skill-tag-viewer>
        </div>
        <div *ngIf="nextStepTags.length>0">
            <div class="skill-group">Skills for <b>next step</b></div>
             <app-skill-tag-viewer *ngFor="let _tag of nextStepTags" [tag]="_tag" [tagMap]="exerciseResult.tagDescriptions"></app-skill-tag-viewer>
        </div>
        <div *ngIf="correctTags.length>0">
            <div class="skill-group">Skills from <b>solved questions</b></div>
             <app-skill-tag-viewer *ngFor="let _tag of correctTags" [tag]="_tag" [tagMap]="exerciseResult.tagDescriptions"></app-skill-tag-viewer>
        </div>
    </div>

</div>